<template>
    <component
        :is="scrollbarTag"
        class="vx-scroll-area"
        :class="{ 'no-scroll-x': preventScrollX }"
        :settings="settings"
        ref="scrollArea"
        :key="$vs.rtl"
    >
        <slot></slot>
    </component>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
    name: 'vx-scroll-area',
    components: {
        VuePerfectScrollbar
    },
    props: {
        maxScrollbarLength: {
            type: Number,
            default: 60
        },
        wheelSpeed: {
            type: Number,
            default: 0.6
        },
        swipeEasing: {
            type: Boolean,
            default: false
        },
        htmlTag: {
            type: String
        },
        preventScrollX: {
            type: Boolean,
            default: false
        },
        rememberPosition: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            lastKnownScrollX: 0,
            lastKnownScrollY: 0
        }
    },
    computed: {
        settings() {
            return {
                maxScrollbarLength: this.maxScrollbarLength,
                wheelSpeed: this.wheelSpeed,
                swipeEasing: this.swipeEasing
            }
        },
        scrollbarTag() {
            return this.htmlTag || this.is_touch_device ? 'div' : 'VuePerfectScrollbar'
        },
        is_touch_device() {
            var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')
            var mq = function (query) {
                return window.matchMedia(query).matches
            }

            if ('ontouchstart' in window || window.DocumentTouch) {
                return true
            }

            // include the 'heartz' as a way to have a non matching MQ to help terminate the join
            // https://git.io/vznFH
            var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('')
            return mq(query)
        }
    },
    methods: {
        scrollToTop() {
            if (this.$refs.scrollArea) {
                const scroll_el = this.$refs.scrollArea.$el || this.$refs.scrollArea
                if (scroll_el) {
                    scroll_el.scrollTop = 0
                }
            }
        },
        scrollToBottom(offset) {
            if (this.$refs.scrollArea) {
                const scroll_el = this.$refs.scrollArea.$el || this.$refs.scrollArea
                if (scroll_el) {
                    scroll_el.scrollTop = scroll_el.scrollHeight
                }
            }
        },
        recordScrollPosition(e) {
            this.lastKnownScrollX = e.target.scrollLeft
            this.lastKnownScrollY = e.target.scrollTop
        }
    },
    mounted() {
        if (this.rememberPosition) {
            var element = this.$refs.scrollArea.$el || this.$refs.scrollArea
            element.addEventListener('scroll', this.recordScrollPosition)
        }
    },
    activated() {
        if (this.rememberPosition) {
            this.$refs.scrollArea.$el.scrollTo(this.lastKnownScrollX, this.lastKnownScrollY)
        }
    }
}
</script>

<style scoped>
.scroll-wrapper {
    overflow-y: hidden;
    height: 100%;
    width: 100%;
}
</style>

<style lang="scss" scoped>
.vx-scroll-area {
    position: relative;
    margin: auto;
    width: 100%;
    height: 100%;

    &:not(.ps) {
        overflow-y: auto;
    }
}

.no-scroll-x {
    ::v-deep .ps__scrollbar-x-rail {
        display: none !important;
    }
}
</style>
